class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // 添加新的选择器
    this.addToCartButton = document.getElementById('add-to-cart-drawer');
    this.productSelector = document.getElementById('product-selector');
    
    // 绑定新的事件
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }

    // 初始化倒计时
    this.initializeCountdown();
  }

  initializeCountdown() {
    // 如果购物车不为空，启动倒计时
    const cartItems = document.querySelectorAll('.cart-item');
    if (cartItems.length > 0) {
      this.startNewCountdown();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // 立即更新倒计时显示
    const textElement = document.querySelector('#cart-countdown-text');
    if (textElement) {
      const expireTime = localStorage.getItem('cart-expire-time');
      if (expireTime) {
        const diff = expireTime - Date.now();
        const minutes = Math.floor(diff / 1000 / 60);
        const seconds = Math.floor((diff / 1000) % 60);
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
        const countdownText = textElement.dataset.countdownText;
        textElement.textContent = countdownText.replace("[countdown]", `${formattedMinutes}:${formattedSeconds}`);
      }
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      
      // 重新绑定关闭按钮事件
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      
      // 重新绑定添加到购物车按钮事件
      const addToCartButtons = this.querySelectorAll('.drawer__add-button');
      addToCartButtons.forEach(button => {
        button.addEventListener('click', this.handleAddToCart.bind(this));
      });
      
      // 重新开始倒计时
      this.startNewCountdown();
    }, 100);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  async handleAddToCart(event) {
    const button = event.target;
    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    const variantId = button.dataset.variantId;
    
    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      const data = await response.json();

      if (response.ok) {
        // 获取最新的购物车数据
        const cartResponse = await fetch('?section_id=cart-drawer');
        const cartHTML = await cartResponse.text();
        
        // 更新购物车内容
        const parsedCart = {
          sections: {
            'cart-drawer': cartHTML,
            'cart-icon-bubble': await (await fetch('?section_id=cart-icon-bubble')).text()
          }
        };
        
        this.renderContents(parsedCart);
      } else {
        console.error('Error:', data.description);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      button.classList.remove('loading');
    }
  }

  // 添加倒计时功能
  startCountdown(forceRestart = false) {
    const textElement = document.querySelector('#cart-countdown-text');
    if (!textElement) return;
    
    const countdownText = textElement.dataset.countdownText;
    if (!countdownText) return;
    
    const expireTime = localStorage.getItem('cart-expire-time');
    if (!expireTime) return;
    
    // 清除之前的定时器
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    
    const updateTimer = () => {
      const diff = expireTime - Date.now();
      
      if (diff <= 0) {
        textElement.textContent = countdownText.replace("[countdown]", "00:00");
        clearInterval(this.countdownInterval);
        return;
      }
      
      const minutes = Math.floor(diff / 1000 / 60);
      const seconds = Math.floor((diff / 1000) % 60);
      
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
      
      textElement.textContent = countdownText.replace("[countdown]", `${formattedMinutes}:${formattedSeconds}`);
    };
    
    // 立即更新一次
    updateTimer();
    
    // 每秒更新
    this.countdownInterval = setInterval(updateTimer, 1000);
  }

  // 添加购物车计数更新方法
  updateCartCount(cartData) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          const cartCount = bubble.querySelector('span[aria-hidden="true"]');
          if (cartCount) cartCount.textContent = cart.item_count;
          
          const cartCountAccessible = bubble.querySelector('.visually-hidden');
          if (cartCountAccessible) {
            cartCountAccessible.textContent = cart.item_count === 1 
              ? window.accessibilityStrings.oneCartCount 
              : window.accessibilityStrings.otherCartCount.replace('[count]', cart.item_count);
          }
        });
      });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // 检查购物车状态并启动倒计时
  checkCartAndStartCountdown() {
    const cartItems = document.querySelectorAll('.cart-item');
    const cartTimer = document.querySelector('#cart-timer');
    
    if (cartItems.length > 0) {
      // 有商品时显示倒计时并启动
      if (cartTimer) {
        cartTimer.style.display = 'block';
      }
      // 延迟启动倒计时，确保DOM完全渲染
      setTimeout(() => {
        this.startCountdown();
      }, 200);
    } else {
      // 没有商品时隐藏倒计时
      if (cartTimer) {
        cartTimer.style.display = 'none';
      }
      // 清除倒计时
      this.isCountdownActive = false;
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }
  }

  startNewCountdown() {
    const cartItems = document.querySelectorAll('.cart-item');
    const cartTimer = document.querySelector('#cart-timer');
    const textElement = document.querySelector('#cart-countdown-text');
    
    if (!cartTimer || !textElement) return;
    
    if (cartItems.length > 0) {
      // 显示倒计时元素
      cartTimer.style.display = 'block';
      
      // 重新开始计时
      const countdownMinutes = window.countdownSettings?.duration || 15;
      const expireTime = Date.now() + countdownMinutes * 60 * 1000;
      localStorage.setItem('cart-expire-time', expireTime);
      
      // 开始倒计时
      this.startCountdown();
    } else {
      // 没有商品时隐藏倒计时
      cartTimer.style.display = 'none';
      // 清除倒计时
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      localStorage.removeItem('cart-expire-time');
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  // 重写父类方法，在购物车更新时触发倒计时
  updateCart() {
    super.updateCart();
    
    // 获取购物车数据并重新渲染
    fetch('?section_id=cart-drawer')
      .then(response => response.text())
      .then(async (responseText) => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const parsedCart = {
            sections: {
              'cart-drawer': responseText,
              'cart-icon-bubble': await (await fetch('?section_id=cart-icon-bubble')).text()
            }
          };
          
          // 渲染新内容
          cartDrawer.renderContents(parsedCart);
        }
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// 在页面加载时检查并启动倒计时
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.initializeCountdown();
  }
});
